/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  GlobalEntityData
} from '../../model/globalEntityData'
import type {
  GlobalEntityDataList
} from '../../model/globalEntityDataList'
import type {
  GlobalEntityDataRequest
} from '../../model/globalEntityDataRequest'
import type {
  GlobalEntityListParams
} from '../../model/globalEntityListParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Get a list of global entities
 */
export const globalEntityList = (
    params?: GlobalEntityListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GlobalEntityDataList>(
      {url: `/global-entity/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGlobalEntityListQueryKey = (params?: GlobalEntityListParams,) => {
    return [`/global-entity/`, ...(params ? [params]: [])] as const;
    }

    
export const getGlobalEntityListQueryOptions = <TData = Awaited<ReturnType<typeof globalEntityList>>, TError = unknown>(params?: GlobalEntityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof globalEntityList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGlobalEntityListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof globalEntityList>>> = ({ signal }) => globalEntityList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof globalEntityList>>, TError, TData> & { queryKey: QueryKey }
}

export type GlobalEntityListQueryResult = NonNullable<Awaited<ReturnType<typeof globalEntityList>>>
export type GlobalEntityListQueryError = unknown

export const useGlobalEntityList = <TData = Awaited<ReturnType<typeof globalEntityList>>, TError = unknown>(
 params?: GlobalEntityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof globalEntityList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGlobalEntityListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGlobalEntityListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof globalEntityList>>, TError = unknown>(params?: GlobalEntityListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof globalEntityList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGlobalEntityListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof globalEntityList>>> = ({ signal }) => globalEntityList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof globalEntityList>>, TError, TData> & { queryKey: QueryKey }
}

export type GlobalEntityListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof globalEntityList>>>
export type GlobalEntityListSuspenseQueryError = unknown

export const useGlobalEntityListSuspense = <TData = Awaited<ReturnType<typeof globalEntityList>>, TError = unknown>(
 params?: GlobalEntityListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof globalEntityList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGlobalEntityListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getGlobalEntityListLoader = (queryParamsOrFn?: (GlobalEntityListParams | ((params: Params) => GlobalEntityListParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getGlobalEntityListQueryKey(queryParams),
            queryFn: () => globalEntityList(queryParams),
          }).then(() => null);
        });
      /**
 * Create entity
 */
export const globalEntityCreate = (
    globalEntityDataRequest: GlobalEntityDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<GlobalEntityData>(
      {url: `/global-entity/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: globalEntityDataRequest
    },
      options);
    }
  


export const getGlobalEntityCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof globalEntityCreate>>, TError,{data: GlobalEntityDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof globalEntityCreate>>, TError,{data: GlobalEntityDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof globalEntityCreate>>, {data: GlobalEntityDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  globalEntityCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GlobalEntityCreateMutationResult = NonNullable<Awaited<ReturnType<typeof globalEntityCreate>>>
    export type GlobalEntityCreateMutationBody = GlobalEntityDataRequest
    export type GlobalEntityCreateMutationError = unknown

    export const useGlobalEntityCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof globalEntityCreate>>, TError,{data: GlobalEntityDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getGlobalEntityCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get request for a global entity
 */
export const globalEntityRetrieve = (
    id: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GlobalEntityData>(
      {url: `/global-entity/${id}/`, method: 'GET', signal
    },
      options);
    }
  

export const getGlobalEntityRetrieveQueryKey = (id: string,) => {
    return [`/global-entity/${id}/`] as const;
    }

    
export const getGlobalEntityRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof globalEntityRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof globalEntityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGlobalEntityRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof globalEntityRetrieve>>> = ({ signal }) => globalEntityRetrieve(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof globalEntityRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type GlobalEntityRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof globalEntityRetrieve>>>
export type GlobalEntityRetrieveQueryError = unknown

export const useGlobalEntityRetrieve = <TData = Awaited<ReturnType<typeof globalEntityRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof globalEntityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGlobalEntityRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGlobalEntityRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof globalEntityRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof globalEntityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGlobalEntityRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof globalEntityRetrieve>>> = ({ signal }) => globalEntityRetrieve(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof globalEntityRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type GlobalEntityRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof globalEntityRetrieve>>>
export type GlobalEntityRetrieveSuspenseQueryError = unknown

export const useGlobalEntityRetrieveSuspense = <TData = Awaited<ReturnType<typeof globalEntityRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof globalEntityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGlobalEntityRetrieveSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getGlobalEntityRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ id: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { id } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (id) {
            return appQueryClient.prefetchQuery({
              queryKey: getGlobalEntityRetrieveQueryKey(id),
              queryFn: () => globalEntityRetrieve(id),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Edit entity
 */
export const globalEntityUpdate = (
    id: string,
    globalEntityDataRequest: GlobalEntityDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<GlobalEntityData>(
      {url: `/global-entity/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: globalEntityDataRequest
    },
      options);
    }
  


export const getGlobalEntityUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof globalEntityUpdate>>, TError,{id: string;data: GlobalEntityDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof globalEntityUpdate>>, TError,{id: string;data: GlobalEntityDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof globalEntityUpdate>>, {id: string;data: GlobalEntityDataRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  globalEntityUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GlobalEntityUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof globalEntityUpdate>>>
    export type GlobalEntityUpdateMutationBody = GlobalEntityDataRequest
    export type GlobalEntityUpdateMutationError = unknown

    export const useGlobalEntityUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof globalEntityUpdate>>, TError,{id: string;data: GlobalEntityDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getGlobalEntityUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    